// eslint-disable-next-line no-restricted-imports -- pre-existing Immutable usage; migrate off when touched
import { Map } from 'immutable';

import { DELETE_ENTITY_DATA, SET_ENTITY_DATA } from '@sophocles/features/resources/resourceHandlerActions';

// Fairly basic store that will be used to track data about entities after they are fetched.
// Think of this as the meta data store for entities.
function resourceHandlerReducer(state = Map(), action) {
  switch (action.type) {
    case SET_ENTITY_DATA:
      return state.set(action.entity, Map(action.data).merge({ timestamp: new Date().toISOString() }));
    case DELETE_ENTITY_DATA:
      return state.delete(action.entity);
    default:
      return state;
  }
}

export default resourceHandlerReducer;
